<template>
    <div :class="['BaseRadio',className]">
        <label class="BaseRadio__label" v-once>{{translate(label)}}</label>
        <div v-for="(item,index) in items" :key="item.id" class="BaseRadio__item">
            <input type="radio"
                   :id="'radio'+fieldName+'_'+index"
                   :name="'radio'+fieldName"
                   :value="item.id"
                   :checked="value == item.id"
                   @change="change($event)">
            <label class="BaseRadio__item-label" v-once :for="'radio'+fieldName+'_'+index">{{translate(item.name)}}</label>
        </div>
        <BaseErrors :errors="errors"/>
    </div>
</template>

<script>
    import BaseErrors from './BaseErrors.vue';

    export default {
        name: 'BaseRadio',
        components: {
            BaseErrors
        },
        props: {
            //Label above dropdown
            label: {
                type: String,
                required: true
            },
            //Input value of dropdown (id of selected value)
            value: {
                type: String
            },
            //Collection of objects with 'id' and 'name' to show in dropdown
            items: {
                type: Array,
                required: true
            },
            //Form validation errors
            errors: {
                type: Array
            },
            //Name of the field
            fieldName: {
                type: String
            },
            //Additional css class name for styling
            className: {
                type: String
            },
            //Icon class
            icon: {
                type: String
            }
        },
        methods: {
            change: function (e) {
                this.$emit('change', e);
            }
        }
    };
</script>

<style>
    @keyframes ripple {
        0% {
            box-shadow: 0 0 0 1px transparent;
        }

        50% {
            box-shadow: 0 0 0 15px rgba(0,0,0,.1);
        }

        to {
            box-shadow: 0 0 0 15px transparent;
        }
    }

    .BaseRadio {
    }

    .BaseRadio__label {
        font-size: 14px;
        color: rgba(96, 125, 139,0.7);
    }

    .BaseRadio__item {
        margin: 16px 0;
    }

        .BaseRadio__item input[type=radio] {
            display: none;
        }

            .BaseRadio__item input[type=radio]:disabled + label:before {
                border-color: rgba(0,0,0,.2);
            }

            .BaseRadio__item input[type=radio]:checked:disabled + label:before {
                border-color: rgba(0,0,0,.2);
                animation: ripple .2s linear forwards;
            }

            .BaseRadio__item input[type=radio]:checked + label:before {
                border-color: #00bcd4;
                animation: ripple .2s linear forwards;
            }

            .BaseRadio__item input[type=radio]:checked + label:after {
                transform: scale(1);
            }

            .BaseRadio__item input[type=radio]:checked:disabled + label:after {
                background: rgba(0,0,0,.2);
                transform: scale(1);
            }


    .BaseRadio__item-label {
        display: inline-block;
        height: 20px;
        position: relative;
        padding: 0 30px;
        margin-bottom: 0;
        cursor: pointer;
        vertical-align: bottom;
    }

        .BaseRadio__item-label:after, .BaseRadio label:before {
            position: absolute;
            content: "";
            border-radius: 50%;
            transition: all .3s ease;
            transition-property: border-color,-webkit-transform;
            transition-property: transform,border-color;
            transition-property: transform,border-color,-webkit-transform;
        }

        .BaseRadio__item-label:before {
            left: 0;
            top: 0;
            width: 20px;
            height: 20px;
            border: 2px solid #757575;
        }

        .BaseRadio__item-label:after {
            top: 5px;
            left: 5px;
            width: 10px;
            height: 10px;
            -webkit-transform: scale(0);
            transform: scale(0);
            background: #00bcd4;
        }
</style>



// WEBPACK FOOTER //
// BaseRadio.vue?191440e7